import { useMutation } from "@tanstack/react-query";
import * as Api from "./notifications";
import { Document } from "./dtos";

export interface EmailDocumentsProps {
  emailTos: string[];
  message: string;
  documents: Document[];
}

export function useEmailDocuments() {
  return useMutation({
    mutationFn: ({emailTos, message, documents}: EmailDocumentsProps) => 
      Api.emailDocuments(emailTos, message, documents),
  })
}

export interface EmailShareTrackingProps {
  emailTos: string[];
  message: string;
  trackingNumber: string;
}

export function useEmailShareTracking() {
  return useMutation({
    mutationFn: ({emailTos, message, trackingNumber}: EmailShareTrackingProps) => 
      Api.emailShareTracking(emailTos, message, trackingNumber),
  })
}